import { render, staticRenderFns } from "./whatsappConnector.vue?vue&type=template&id=39221b84"
import script from "./whatsappConnector.vue?vue&type=script&lang=js"
export * from "./whatsappConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports